<template>
    <div class="checkbox-wrapper" :class="[alternateStyle ? 'rounded p-4 bg-white/10' : '', (alternateStyle && isChecked) ? '!bg-white/30' : '']">
        <ValidationProvider :rules="rules" v-slot="v">
            <div v-if="!alternateStyle" class="flex">
                <div class="checkbox-container relative mr-4">
                    <input @click="isChecked = !isChecked" v-model="isChecked" :id="id" :name="name" type="checkbox" :class="[v.errors.length ? 'has-errors' : '', 'icon-check  cursor-pointer']" />
                </div>
                <div class="basis-5/6 mb-4" v-if="label || v.errors.length">
                    <label class="label" v-if="label" :for="id" v-html="label"></label>
                    <p v-if="v.errors.length" class="!opacity-100 subtext text-error">{{ v.errors[0] }}</p>
                </div>
            </div>
            <!-- Alternate Style -->
            <div v-else class="flex items-center">
                <div class="flex-1" v-if="label || v.errors.length">
                    <label class="label" v-if="label" :for="id" v-html="label"></label>
                    <p v-if="v.errors.length" class="!opacity-100 subtext text-error">{{ v.errors[0] }}</p>
                </div>
                <div class="checkbox-container relative ml-4">
                    <input @click="isChecked = !isChecked" :id="id" :name="name" v-model="isChecked" type="checkbox" :class="[v.errors.length ? 'has-errors' : '', 'icon-check cursor-pointer']" />
                </div>
            </div>
            <!-- END Alternate Style -->
        </ValidationProvider>
    </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
export default {
    name: "CheckboxComponent",
    props: {
        name: { type: String, default: "" }, // "Name" prop for naming the input
        id: { type: String, default: "" }, // "id" prop for naming the input
        value: { default: "" }, // "Value" prop for setting an initial value for the input
        label: { type: String, default: "" }, // Label used for the input
        rules: { default() { return { required: { allowFalse: false }} } }, // The validation rules set on the input. See VeeValidate for available rules
        alternateStyle: { type: Boolean, default: false }, // Show a different variation/style of a checkbox
    },
    components: {
        ValidationProvider
    },
    computed: {},
    data: function () {
        return {
            isChecked: this.value
        };
    },
    watch: {
		isChecked(value) {
			this.isChecked = !!value;
			this.$emit('input', this.isChecked);
            this.$emit('change', this.isChecked);
		},
        value(value) {
			this.isChecked = !!value;
		}
	}
};
</script>
